<template>
    <div class="pBox">
        <div class="form-box">
            <div class="fl left">
                <form class="form-horizontal">
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">姓名 </label>
                        <div class="col-sm-7">
                            <input type="text" class="form-control"  placeholder="姓名" v-model="data.xm" disabled>
                        </div>
                    </div>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">身份证号 </label>
                        <div class="col-sm-7">
                            <input type="text" class="form-control"  placeholder="身份证号" v-model="data.sfzjh" disabled>
                        </div>
                    </div>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">性别 </label>
                        <div class="col-sm-7">
                            <label class="radio-lable">
                                <input type="radio" name="optionsRadios" id="optionsRadios1" value="1" v-model="data.xbm" disabled>男
                            </label>
                            <label  class="radio-lable">
                                <input type="radio" name="optionsRadios" id="optionsRadios1" value="2" v-model="data.xbm" disabled>女
                            </label>
                        </div>
                    </div>
                    <!-- <div class="form-group">
                        <label  class="col-sm-3 control-label">学制</label>
                        <div class="col-sm-7">
                            <input type="text" class="form-control"  placeholder="学制" v-model="data.xz" disabled>
                        </div>
                    </div> -->
                   
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">籍贯 </label>
                        <div class="col-sm-7">
                            <select class="form-control" v-model="data.jg" disabled>
                                <option :value="item.name" v-for="(item,index) in jgDataList" :key="index">{{item.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">民族  </label>
                        <div class="col-sm-7">
                            <select class="form-control" v-model="data.mzm">
                                <option :value="item.id" v-for="(item,index) in mzDataList" :key="index">{{item.name}}</option>
                            </select>
                        </div>
                    </div>
                     <div class="form-group">
                        <label  class="col-sm-3 control-label">联系号码  </label>
                        <div class="col-sm-7">
                            <input type="text" :class="{red:isRedu}" class="form-control"  placeholder="联系号码" v-model="data.mobile" @change="checkUser">
                        </div>
                    </div>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">政治面貌  </label>
                        <div class="col-sm-7">
                            <select class="form-control" v-model="data.zzmmm" placeholder="政治面貌">
                                <option :value="item.id" v-for="(item,index) in zzmmList" :key="index">{{item.name}}</option>
                            </select>
                        </div>
                    </div>

                <div class="form-group">
                        <label  class="col-sm-3 control-label">毕业学校  </label>
                        <div class="col-sm-7">
                            <input type="text"  class="form-control"  placeholder="毕业学校" v-model="data.graduate_school" >
                        </div>
                    </div>

                      <div class="form-group">
                        <label  class="col-sm-3 control-label">档案类别  </label>
                        <div class="col-sm-7">
                            <select class="form-control" v-model="data.dalb">
                                <option :value="item.id" v-for="(item,index) in daly" :key="index">{{item.name}}</option>
                            </select>
                        </div>
                    </div>
                      <div class="form-group">
                        <label  class="col-sm-3 control-label">户口类型  </label>
                        <div class="col-sm-7">
                            <select class="form-control" v-model="data.household_type">
                                <option :value="item.id" v-for="(item,index) in hklx" :key="index">{{item.name}}</option>
                            </select>
                        </div>
                    </div>
                  
                     <div class="form-group">
                      <label class="col-sm-3 control-label">生源所在地  </label>
                      <div class="col-sm-7 selectss">
                        <select
                        
                          class="form-control my_select"
                          v-model="data.provinceCode"
                          @change="changePro(data.provinceCode)"
                        >
                          <option value disabled>--请选择--</option>
                          <option
                            v-for="(item,index) in provinceList"
                            :key="index"
                            :label="item.area_name"
                            :value="item.area_code"
                          >{{item.area_name}}</option>
                        </select>
                        <select
                          class="form-control my_select"
                          v-model="data.cityCode"
                          @change="changeCity(data.cityCode)"
                        >
                          <option value disabled>--请选择--</option>
                          <option
                            v-for="(item,index) in cityList"
                            :key="index"
                            :label="item.area_name"
                            :value="item.area_code"
                          >{{item.area_name}}</option>
                        </select>
                        <select class="form-control my_select" v-model="data.lydqdm" >
                          <option
                            v-for="(item,index) in dictList"
                            :key="index"
                            :label="item.area_name"
                            :value="item.area_code"
                          >{{item.area_name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">通信地址  </label>
                        <div class="col-sm-7">
                            <input type="text" class="form-control"  placeholder="通信地址" v-model="data.txdz">
                        </div>
                    </div>
                   
                    <div class="form-group">
                        <label  class="col-sm-3 control-label">邮政编码 </label>
                        <div class="col-sm-7">
                            <input type="text" class="form-control"  placeholder="邮政编码" v-model="data.postal_code">
                        </div>
                    </div>
                </form>
            <div class="btn-box">
                <button type="button" class="btn btn-success btn-lg"  data-toggle="modal" data-target="#myModal">提交</button>
            </div>
            </div>
            <div class="fl right">
                <div class="tx-box">
                    <input type="file" id="file" name="file" accept="image/jpeg,image/jif,image/png" @change="uploadimg">
                    <div class="tx-img"><img :src="src"  :onerror="errImg"></div>
                    <button type="button" class="btn btn-default">上传头像</button>
                </div>
            </div>
        </div>
        <!-- 提示框   -->
        <tip :tip="tip" v-show="tipShow"></tip>
        <page-load v-if="flag"></page-load>
        <!-- 模态框 -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
	        <div class="modal-dialog">
		        <div class="modal-content">
			        <div class="modal-header">
				        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                        &times;
				        </button>
				        <h4 class="modal-title" id="myModalLabel">
                        提示框
				        </h4>
			        </div>
                    <h4 class="modal-body">
				        确定提交吗
			        </h4>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">关闭
                        </button>
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="_submit">
                            提交更改
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import {
  getPersonInfo,
  getImg,
  updatePersonInfo,
  uploaddelayImg
} from "@/api/login.js";
import { apiUrl } from "@/api/config";
import { area } from "@/api/api";
import pageLoad from "../pageload/pageload";
let Base64 = require("js-base64").Base64;

export default {
  components: { pageLoad },
  data() {
    return {
      data: {}, //学生信息
      jgDataList: [], //籍贯信息
      mzDataList: [], //名族信息
      zzmmList: [], //政治面貌信息
      src: "", //获取图片信息地址
      errImg: 'this.src="' + require("../assets/imgs/tx.png") + '"',
      tipShow: false, //tip提示
      tip: "", //tip提示信息
      isRedu: false, //控制边框颜色
      url: apiUrl,
      flag: false,
      provinceList: [], //省集合
      cityList: [], //市集合
      dictList: [], //区集合
      daTitle: "",
      hkTitle: "",
      daly: [{ name: "邮寄", id: 1 }, { name: "自带", id: 2 }],
      hklx: [{ name: "城镇户口", id: 1 }, { name: "农村户口", id: 2 }]
    };
  },
  created() {
    setTimeout(() => {
      this._getPersonInfo();
      this._getImg();
    }, 20);
  },
  mounted() {},
  methods: {
    //上传图片
    _uploaddelayImg(str) {
      let module = {
        sch_id: JSON.parse(sessionStorage.getItem("stuInfo")).sch_id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        ),
        file: str,
        ident: 4
      };
      this.flag = true;
      uploaddelayImg(module)
        .then(res => {
          this.flag = false;
          if (res.status) {
            this.tipCtr(res.msg);
          }
        })
        .catch(err => {
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //图片预览
    uploadimg(e) {
      let _this = this;
      var files = e.target.files[0];
      if (!e || !window.FileReader) return;
      let reader = new FileReader();
      reader.readAsDataURL(files);
      reader.onloadend = function() {
        _this.src = this.result;
        _this._uploaddelayImg(_this.src);
      };
    },
    //验证手机号
    checkUser() {
      let reg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
      //判断手机号是否存在
      if (!this.data.mobile) {
        this.isRedu = true;
        this.tipCtr("请输入手机号");
        return false;
      } else if (!reg.test(this.data.mobile)) {
        this.isRedu = true;
        this.tipCtr("请输入正确的手机号");
        return false;
      } else {
        this.isRedu = false;
        return true;
      }
    },
    //提交
    _submit() {
      if (this.checkUser()) {
        this._updatePersonInfo();
      }
    },
    //修改个人信息
    _updatePersonInfo() {
      if (this.daTitle) {
        this.daTitle == "自带" ? (this.daTitle = 1) : (this.daTitle = 2);
      }
      if (this.hkTitle) {
        this.hkTitle == "城镇户口" ? (this.hkTitle = 1) : (this.hkTitle = 2);
      }
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        ),
        mobile: Base64.encode(this.data.mobile),
        mz: this.data.mzm,
        zzmm: this.data.zzmmm,
        lydq: this.data.lydq,
        txdz: this.data.txdz,
        household_type: this.hkTitle,
        dalb: this.daTitle,
        graduate_school: this.data.graduate_school,
        postal_code: this.data.provinceCode,
        lydqdm: this.data.lydqdm,
        province_code_s: this.data.datacityCode,
        cityCode_s: this.data.cityCode,
        lydqdm_s: this.data.lydqdm
      };
      this.flag = true;
      updatePersonInfo(module)
        .then(res => {
          this.flag = false;
          if (res.status) {
            this.tipCtr(res.msg);
          } else {
            this.tipCtr(res.msg);
          }
        })
        .catch(err => {
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //获取头像信息
    _getImg() {
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        )
      };
      getImg(module)
        .then(res => {
          if (res.status) {
            this.flag = false;
            this.src = this.url + res.data.head_url;
          }
        })
        .catch(err => {
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //获取个人信息
    _getPersonInfo() {
      let module = {
        rid: JSON.parse(sessionStorage.getItem("stuInfo")).id,
        idNum: Base64.encode(
          JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
        )
      };
      this.flag = true;
      getPersonInfo(module)
        .then(res => {
          if (res.status) {
            this.flag = false;
            this.data = res.data;
            this.jgDataList = res.jg_data;
            this.mzDataList = res.mzm_data;
            this.zzmmList = res.zzmm_data;
            this._area();
            if (res.data.dalb) {
              res.data.dalb == 1
                ? (this.daTitle = "邮寄")
                : (this.daTitle = "自带");
            } else {
              this.data = "请选择";
            }
            if (res.data.household_type) {
              res.data.household_type == 1
                ? (this.hkTitle = "城镇户口")
                : (this.hkTitle = "农村户口");
            }
          } else {
            this.data = {};
            this.jgDataList = [];
            this.mzDataList = [];
            this.zzmmList = [];
          }
        })
        .catch(err => {
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //省市区
    _area() {
      let module = {
        area_code: "000000"
      };
      area(module)
        .then(res => {
          if (res.status && res.data && res.data.length > 0) {
            this.provinceList = res.data;
            if (this.data.provinceCode != "") {
              this.changePro(this.data.provinceCode);
            }
          } else {
            this.loading = false;
            this.tipCtr(res.msg);
          }
        })
        .catch(err => {
          this.loading = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //换省
    changePro(item) {
      if (item == undefined) {
        return;
      }
      let module = {
        area_code: item
      };
      area(module)
        .then(res => {
          if (res.status && res.data && res.data.length > 0) {
            this.cityList = res.data;
            if (this.data.cityCode != "") {
              this.changeCity(this.data.cityCode);
            }
          } else {
            this.loading = false;
            this.data.cityCode = "";
            this.data.provinceCode = "";
            this._areaFn();
          }
        })
        .catch(err => {
          this.loading = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    }, //换市
    changeCity(item) {
      if (item == undefined) {
        return;
      }
      let module = {
        area_code: item
      };
      this.loading = false;
      area(module)
        .then(res => {
          if (res.status && res.data && res.data.length > 0) {
            this.dictList = res.data;
          } else {
            this.tipCtr(res.msg);
          }
        })
        .catch(err => {
          this.loading = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //提示框方法
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1500);
    }
  }
};
</script>
<style scoped>
.left {
  width: 70%;
  padding: 30px 0;
}
.left i {
  color: red;
  font-size: 16px;
  display: inline-block;
  margin-right: -10px;
}
.red {
  border: 1px solid red;
}
.form-group {
  margin-bottom: 20px;
}
/***input***/
.form-control {
  height: 40px;
  font-size: 14px;
  color: #333;
}
.radio-lable {
  padding-top: 9px;
  margin-right: 40px;
  cursor: pointer;
}

input[type="radio"] {
  /*radiobox   原始 样式修改   */
  width: 20px;
  height: 20px;
  margin: -2px 5px 0 0 !important;
  vertical-align: middle;
  cursor: pointer;
  background-color: #fff;
  -webkit-appearance: none;
  border: 1px solid #c9c9c9;
  outline: none;
  border-radius: 100%;
}
input[type="radio"]:checked {
  background: #ff9000;
  border: none;
}
.right {
  width: 28%;
  padding: 30px 0;
}
.btn-box {
  text-align: center;
}
.btn-box button {
  margin-top: 30px;
  min-width: 40%;
}
/*头像*/
.tx-box {
  width: 100%;
  position: relative;
}
.tx-box input {
  position: absolute;
  width: 82px;
  height: 32px;
  left: 20px;
  bottom: 20px;
  opacity: 0;
  cursor: pointer;
}
.tx-box button {
  margin: 20px;
}
.tx-img {
  width: 140px;
  height: 160px;
  overflow: hidden;
  box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.2);
  padding: 5px;
  border: 1px #ddd solid;
  cursor: pointer;
}
.tx-img img {
  width: 100%;
  height: 100%;
}
.selectss select {
  width: 32%;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/personInfo.vue